import type { FC } from 'react';
import PropTypes from 'prop-types';
import { GetIcon } from '../../icons';
import { Asset } from '../asset';
import { LARGER_DEVICE_IMAGES_TO_SHOW } from '../constants';
import { usePhotoGridStoreMutation } from '../usePhotoStore';
import { AssetInfoPropTypes, AssetType } from '../utils';
import type { AssetInfo } from '../utils';

interface AssetColumnProps {
    assets: AssetInfo[];
    isMainColumn?: boolean;
    dataTestId?: string;
}

export const AssetColumn: FC<AssetColumnProps> = ({ assets, dataTestId, isMainColumn }) => {
    const mutation = usePhotoGridStoreMutation();
    return (
        <div className="flex flex-1 flex-col space-y-2" data-testid={dataTestId}>
            {assets.map((asset, idx) => (
                <button
                    key={asset.id}
                    className="relative overflow-hidden md:rounded-lg"
                    type="button"
                    onClick={() =>
                        mutation.mutate({
                            selectedAsset: asset,
                            isZoomModalOpen: true,
                        })
                    }
                >
                    <Asset
                        asset={asset}
                        shouldLazyLoad={idx >= LARGER_DEVICE_IMAGES_TO_SHOW}
                        hasHighFetchPriority={
                            (!!isMainColumn && idx === 0) ||
                            (!isMainColumn && asset.assetType === AssetType.BRAND_SPECIALIST_VIDEO)
                        }
                    />
                    <div className="absolute bottom-4 right-4 leading-[0]">
                        <GetIcon name="expand-arrow-circle" size="sm" />
                    </div>
                </button>
            ))}
        </div>
    );
};

AssetColumn.propTypes = {
    assets: PropTypes.arrayOf(AssetInfoPropTypes.isRequired).isRequired,
    isMainColumn: PropTypes.bool,
    dataTestId: PropTypes.string,
};

AssetColumn.defaultProps = {
    dataTestId: undefined,
    isMainColumn: false,
};
